<template>
  <!-- 货物信息 -->
  <div class="enter-storage margin-top">
    <CargoForm
      ref="cargoForm"
      :theadData="theadNewData"
      :tableData="tableListData"
      :index="index"
      :rules="rules"
      @copy="copy"
      @del="del"
    />
    <Product ref="product" :productList="productListData" :rules="productRules" @add="productAdd" />
    <!-- 商品列表 -->
    <el-dialog title="商品列表" width="850px" :visible.sync="goodsTypeShow">
      <div class="typeHeader LR_center">
        <div>
          <el-input
            style="width: 314px"
            placeholder="请输入中文品名"
            v-model="Sgodname"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              type="primary"
              @click="pageNum = 1,getgoodsData(Sgodname)"
            >搜索</el-button>
          </el-input>
        </div>
        <div>
          <el-select
            clearable
            @change="pageNum = 1,getgoodsData(Sgodname)"
            v-model="ThatgoodsID"
            style="width: 100%"
            ref="changeFBAgoodtype"
            placeholder="请选择"
          >
            <el-option
              v-for="res in goodstypelist"
              :key="res.id"
              :label="res.namec"
              :value="res.id"
            ></el-option>
          </el-select>
        </div>
        <div>
          <el-button type="primary" icon="el-icon-plus" plain @click="addgoods()">新增商品</el-button>
        </div>
      </div>
      <div class="countTable" style="margin-top: 30px">
        <el-table
          ref="multipleTable"
          border
          :data="goodsLabel"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="中文名称" align="center" width="120">
            <template slot-scope="scope">{{ scope.row.namec }}</template>
          </el-table-column>
          <el-table-column prop="namee" label="英文品名" align="center" width="120"></el-table-column>
          <el-table-column prop="materialc" align="center" label="中文材质"></el-table-column>
          <el-table-column prop="purposec" align="center" label="用途"></el-table-column>
          <el-table-column prop="hsCode" align="center" label="海关编码"></el-table-column>
          <el-table-column prop="declaredValue" align="price" label="货值"></el-table-column>
          <el-table-column prop="goodstype" align="price" label="商品类型"></el-table-column>
        </el-table>
        <div
          class="qdBtn TB_center"
          style="width: 100%; margin-top:20px;display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;"
        >
          <el-pagination
            background
            @current-change="handleCurrentChange"
            layout="total,prev, pager, next"
            :page-size="20"
            :total="goodslisttotal"
          ></el-pagination>
        </div>
        <div class="qdBtn TB_center" style="width: 100%; margin-top:20px">
          <el-button type="primary" @click="setGoodspush()">确认选择</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 商品列表END -->
  </div>
</template>

<script>
import Product from './product'
import CargoForm from './cargo-form'
export default {
  components: {
    Product,
    CargoForm
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    },
    productList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    const fbxbox = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入箱号'))
      } else {
        if (this.delegationRuleForm.inwarehouseType === 'FBA') {
          if (value.toLowerCase().indexOf('fba') === 0) {
            if (value.length < 19 || value.length > 19) {
              callback(new Error('长度必须为19位字符'))
            } else {
              callback()
            }
          } else {
            callback(new Error('必须以FBA字符开头'))
          }
        } else {
          callback()
        }
      }
    }
    const poTrackingNo = (rule, value, callback) => { // 货件追踪号
      if (!value) {
        callback(new Error('请输入货件追踪号'))
      } else {
        if (this.delegationRuleForm.inwarehouseType === 'FBA' && this.delegationRuleForm.countrycode === 'SA') {
          if (value.length > 8 || value.length < 8) {
            callback(new Error('长度只能为8个字符'))
          } else {
            var reg = /^[a-zA-Z0-9]+$/
            if (!reg.test(value)) {
              callback(new Error('只能为数字和字母'))
            } else {
              callback()
            }
          }
        } else {
          callback()
        }
      }
    }
    const number = (rule, value, callback) => {
      if (value === '') {
        // eslint-disable-next-line standard/no-callback-literal
        return callback('请输入数量')
      } else {
        if (!this.$utils.checkNumber(value)) {
          // eslint-disable-next-line standard/no-callback-literal
          return callback('请输入正确的数字')
        }
        if (value === 0) {
          // eslint-disable-next-line standard/no-callback-literal
          return callback('数值必须大于0')
        } else {
          if (!this.$utils.checkNumberInteger(value, '+')) {
            console.log('value: ', value)
            // eslint-disable-next-line standard/no-callback-literal
            return callback('必须是整数')
          } else {
            // eslint-disable-next-line standard/no-callback-literal
            return callback()
          }
        }
      }
    }
    return {

      BoxWrapindex: '',
      goodslisttotal: 0,
      goodsLabel: [],
      goodstypelist: [],
      thatGoodslist: [],
      pageNum: 1,
      Sgodname: '',
      goodsTypeShow: false,
      ThatgoodsID: '',
      thatindexgslist: [],
      theadData: [
        {
          label: '序号',
          align: 'center',
          prop: 'index'
        },
        {
          label: '运单号',
          name: 'fbxbox',
          type: 'input',
          disabled: true,
          prop: 'fbxbox'
        }, {
          label: '箱号',
          name: 'fbxbox',
          type: 'input',
          disabled: true,
          prop: 'fbxbox'
        }, {
          label: '*FBX货箱号',
          name: 'fbxbox',
          type: 'input',
          prop: 'fbxbox'
        },
        {
          label: '*货件追踪号',
          name: 'poTrackingNo',
          type: 'input',
          prop: 'poTrackingNo',
          showType: false
        },
        {
          label: '*商铺号',
          name: 'shopName',
          type: 'input',
          prop: 'shopName',
          showType: false
        },
        {
          label: '*长(CM)',
          name: 'length',
          type: 'input',
          prop: 'length'
        },
        {
          label: '*宽(CM)',
          name: 'width',
          type: 'input',
          prop: 'width'
        },
        {
          label: '*高(CM)',
          name: 'height',
          type: 'input',
          prop: 'height'
        },
        {
          label: '*单箱重(KG)',
          name: 'weight',
          type: 'input',
          prop: 'weight'
        },
        {
          label: '操作',
          prop: 'operation',
          name: 'operation',
          options: {
            copy: true,
            delete: true
          }
        }
      ],
      rules: {
        fbxbox: { // fbx号
          required: true, validator: fbxbox, trigger: 'blur'
        },
        poTrackingNo: { // 追踪号
          required: false, validator: poTrackingNo, trigger: 'blur'
        },
        length: {
          required: true, message: '请输入长', trigger: 'blur'
        },
        shopName: {
          required: false, message: '商户号不能为空', trigger: 'blur'
        },
        width: {
          required: true, message: '请输入宽', trigger: 'blur'
        },
        height: {
          required: true, message: '请输入高', trigger: 'blur'
        },
        weight: {
          required: true, message: '请输入单箱重', trigger: 'blur'
        }
      },
      productRules: {
        price: {
          required: true, message: '请输入价格', trigger: 'blur'
        },
        number: {
          required: true, validator: number, trigger: 'blur'
        }
      },
      delegationRuleForm: {}
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    tableListData () {
      const list = []
      this.tableData.forEach((item) => {
        item.index = this.index + 1
        list.push({ ...item })
      })
      return list
    },
    theadNewData () {
      console.log('this.theadData: ', this.theadData)
      return this.theadData
    },
    productListData () {
      return this.productList
    }
  },
  created () {
  },
  methods: {
    transmit (data) { // 接受实时ConsignInformation组件的表单值
      console.log('ConsignInformation---data: ', data)
      this.delegationRuleForm = data
      if (data.inwarehouseType === 'FBA' && data.countrycode === 'SA') { // 添加表头并校验
        this.theadData.map((item) => {
          if (item.name === 'poTrackingNo' || item.name === 'shopName') {
            console.log('item: ', item)
            this.$set(item, 'showType', true)
            this.$set(this.rules[item.name], 'required', true)
          }
        })
      } else {
        this.theadData.map((item) => {
          if (item.name === 'poTrackingNo' || item.name === 'shopName') {
            console.log('item: ', item)
            this.$set(item, 'showType', false)
            this.$set(this.rules[item.name], 'required', false)
          }
        })
      }
    },
    productAdd () { // 添加商品  index 未传
      console.log('index: ', this.index)
      const data = this.$refs.product.submit()
      if (!data) {
        return
      }
      this.Sgodname = ''
      this.ThatgoodsID = ''

      if (!this.delegationRuleForm.companyid) return this.$message({ message: '请选择委托公司', type: 'info' })
      if (this.delegationRuleForm.desWarehouseId.length < 1) return this.$message({ message: '请选择目的仓库', type: 'info' })
      this.thatindexgslist = []
      if (this.$parent.enterStorageList[this.index].productList.length > 0) { // if 当前箱子内有货物
        this.$parent.enterStorageList[this.index].productList.forEach(item => {
          this.thatindexgslist.push(item)
        })
      } else {
        this.thatindexgslist = []
      }
      this.BoxWrapindex = this.index
      this.goodsTypeShow = true
      this.getgoodsData() // 查询商品列表
      this.getGoodstypelist()
    },
    handleSelectionChange (val) {
      this.thatGoodslist = val
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.pageNum = val
      this.getgoodsData()
    },
    copy () { // 复制数据
      this.$emit('copy', JSON.parse(JSON.stringify({ tableData: this.tableListData, productList: this.productListData })))
    },
    del () { // 删除箱子
      this.$emit('del', this.index)
    },
    submit () {
      const cargoForm = this.$refs.cargoForm.submit()
      const productList = this.$refs.product.submit()
      console.log('productList: ', productList)
      console.log('cargoForm: ', cargoForm)
      return {
        cargoForm, productList
      }
    },
    setGoodspush () { // 确定添加
      if (this.thatGoodslist.length == 0) return this.$message('请选择商品')
      const arr1 = JSON.parse(JSON.stringify(this.$parent.enterStorageList[this.BoxWrapindex].productList))
      this.thatGoodslist.forEach((item) => {
        arr1.push(item)
      })
      const newArr = []
      arr1.forEach(el => {
        const result = newArr.findIndex(ol => { return el.id == ol.id })
        if (result !== -1) {
          newArr[result].number = newArr[result].number + el.number
        } else {
          newArr.push(el)
        }
      })
      if (this.starCurrenty !== this.endCurrenty) { // 如果不是本地fba 则校验
        const newarray = this.thatindexgslist.concat(this.thatGoodslist)
        let idlist = []
        newarray.forEach(item => {
          idlist.push(item.goodstypeid)
        })
        idlist = [...new Set(idlist)]
        if (idlist.length > 1) return this.$message('单箱内只能放入同一种货物类型')
        if (this.countrycode === 'SA') {
          if (newArr.length > 3) return this.$message('单箱子内商品类型不能超过3件')
        }
      }
      this.$parent.enterStorageList[this.BoxWrapindex].productList = newArr
      this.$parent.enterStorageList[this.BoxWrapindex].goodstypeid = newArr[0].goodstypeid
      this.goodsTypeShow = false
      // this.setFormdata(); //海运费
    },
    getgoodsData (name) {
      // 获取商品列表
      const params = {
        customerid: this.delegationRuleForm.companyid,
        goodstypeid: this.ThatgoodsID,
        name: name,
        towarehouseid: this.delegationRuleForm.desWarehouseId[1],
        curPage: this.pageNum,
        pageSize: 20
      }
      this.axios
        .post('service?src=fbxOnline&action=getFbxCustomerGoodsCategoryList', params)
        .then((res) => {
          console.log(res.data.data.dataList)
          if (res.data.isSuccess) {
            if (res.data.data.dataList) {
              res.data.data.dataList.forEach(item => {
                this.$set(item, 'number', 1)
              })
              this.goodsLabel = res.data.data.dataList
              this.goodslisttotal = res.data.data.totalCount
            } else {
              this.goodsLabel = []
            }
          } else {
          }
        })
        .catch((res) => {

        })
    },
    getGoodstypelist () {
      // 商品类型
      this.axios
        .get(`service?src=fbxOnline&action=findAllGoodsType&towarehouseid=${this.delegationRuleForm.desWarehouseId[1]}`)
        .then((res) => {
          console.log(res)
          this.goodstypelist = res.data.data
        })
        .catch((res) => {

        })
    }
  }
}
</script>

<style scoped >
.enter-storage {
  box-sizing: border-box;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
</style>



// WEBPACK FOOTER //
// src/components/mainOrders/components/enter-storage.vue